module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usage"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("便捷的使用方式")]), _c('ul', [_c('li', [_vm._v("灵活的调度比例配置")]), _c('li', [_vm._v("部署秒级生效")]), _c('li', [_vm._v("多域名统一维护、管理")]), _c('li', [_vm._v("服务状况一目了然")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-340097e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/usage.vue
// module id = 46
// module chunks = 0